import { useOnlineStatus } from "@/composables/global/useOnlineStatus"
import { watch, ref } from "vue"
import { useMessage } from "naive-ui"

export function useConnectivityToast() {
  const { online } = useOnlineStatus()
  const message = useMessage()
  const isFirstRun = ref(true)

  watch(online, (v) => {
    // Skip the first notification on mount to avoid annoying users
    if (isFirstRun.value) {
      isFirstRun.value = false
      return
    }

    if (v) message.success("Online — syncing changes…", { duration: 2000 })
    else message.warning("Offline — changes will be queued", { duration: 2000 })
  })
}
